<template>
    <div class="learnSort">
        <slot name="sortImg"></slot>
        <div class="sortText">
            <slot name="sortText"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.learnSort{
    width: 173px;
    height: 314px;
    position: relative;
    .sortImg{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .sortText{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        writing-mode: vertical-lr;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
    }
}
</style>
